import * as React from 'react';
import Button from '~/UI/Button';

import { AnnexForm1, AnnexForm1Values } from './AnnexForm1';

export interface FormValues {
	exportAnnex1: AnnexForm1Values;
}

export const Form: React.FunctionComponent<
	React.PropsWithChildren<{
		disabled: boolean;
		values: FormValues;
		onChange(values: FormValues): void;
		onSubmit(): void;
	}>
> = ({ disabled, values, onChange, onSubmit }) => {
	const submit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		onSubmit();
	};

	return (
		<form onSubmit={submit}>
			<AnnexForm1
				disabled={disabled}
				values={values.exportAnnex1}
				onChange={(exportAnnex1) => {
					onChange({ ...values, exportAnnex1 });
				}}
			/>
			<Button disabled={disabled}>Save</Button>
		</form>
	);
};
